function GetAuthorizationCode(GoogleCode) {
    const form = document.createElement('form');
    form.method = "post";
    form.action = "https://auth.dice.tech/auth/employee/sso";

    let params = {
        type: 'google',
        token: GoogleCode,
        referrer: window.location.origin,
        redirect: 'https://oauth.dice.tech',
        client_id: "6104530easd577f-11ed-9b6a-0242ac120002"
    }

    for (const key in params) {
        if (params.hasOwnProperty(key)) {
            const hiddenField = document.createElement('input');
            hiddenField.type = 'hidden';
            hiddenField.name = key;
            hiddenField.value = params[key];
            form.appendChild(hiddenField);
        }
    }
    document.body.appendChild(form);
    try {
        form.submit();
    } catch (err) {
        console.log(err);
    }
}
export default GetAuthorizationCode;